import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import membersStrings from 'modules/members/strings';
import Modal from 'modules/common/components/Modal';
import { status } from 'constants/general';

import { AddIcon, Button, MinusIcon } from './UpdatePointsButton.style';
import UpdatePointsForm from '../UpdatePointsForm';

const { awardPoints, deductPoints } = membersStrings.memberProfile;

const UpdatePointsButton = ({ toAddPoints }) => {
  const [isModalHidden, setIsModalHidden] = useState(true);

  const { member } = useSelector(state => state.members);
  const { updatingPointsStatus } = member;

  const closeModal = () => {
    setIsModalHidden(true);
  };

  return (
    <>
      <Modal
        isModalHidden={isModalHidden}
        onCloseModal={() => {
          setIsModalHidden(true);
        }}
      >
        <UpdatePointsForm toAddPoints={toAddPoints} closeModal={closeModal} />
      </Modal>
      <Button
        type="button"
        disabled={updatingPointsStatus === status.FETCHING}
        onClick={() => {
          setIsModalHidden(false);
        }}
      >
        {toAddPoints ? (
          <>
            <AddIcon /> {awardPoints}
          </>
        ) : (
          <>
            <MinusIcon /> {deductPoints}
          </>
        )}
      </Button>
    </>
  );
};

UpdatePointsButton.propTypes = {
  toAddPoints: PropTypes.bool,
};

UpdatePointsButton.defaultProps = {
  toAddPoints: true,
};

export default UpdatePointsButton;
